<template>
  <div :style="style" class="bg-center"></div>
</template>

<script>
export default {
  name: 'Separator',
  props: ['pattern'],
  computed: {
    style() {
      return {
        backgroundImage:
          'url(' + require(`@/assets/pattern-${this.$props.pattern}.svg`) + ')',
      }
    },
  },
}
</script>
